import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {Views} from '@ccp/config/views';
import {FeatureToggleService} from '@ccp/app/services/toggle-features/feature-toggle.service';
import {ToggleFeatures} from '@ccp/app/enums/toggleFeatures.enum';

export const DigitalCertificateGuard: CanActivateFn = (route) => {
  const featureToggleService = inject(FeatureToggleService);
  const router = inject(Router);
  if (featureToggleService.featureConfig$().getConfig(ToggleFeatures.digitalCertificate)) {
    return true;
  } else {
    return router.createUrlTree([Views.productRegister.path], {
      queryParams: {...route.queryParams},
    });
  }
};
